export default "__VITE_ASSET__BdNz9lvT__"